export enum ProductClassification  {
    FTTH = 1,
    FTTB= 2,
    FTTHFTTB= 3
}
